import { render, staticRenderFns } from "./UserBranches.vue?vue&type=template&id=546ac910&"
import script from "./UserBranches.vue?vue&type=script&lang=js&"
export * from "./UserBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports